// Convention : tout booléen qui pilote l'affichage de <LoadingScreen/> doit passer par
// useMinDuration (src/hooks/useMinDuration.ts) pour garantir un affichage d'au moins 800ms —
// évite un flash trop bref si l'opération se termine quasi instantanément.

interface LoadingScreenProps {
  /** Texte affiché sous le spinner. Défaut : "Chargement…" */
  message?: string;
  /** Si true : overlay fixe plein écran (z-index 9999) au lieu d'un bloc normal. */
  overlay?: boolean;
}

export default function LoadingScreen({ message = "Chargement…", overlay = false }: LoadingScreenProps) {
  return (
    <div style={{
      ...(overlay
        ? { position: "fixed", inset: 0, zIndex: 9999,
            background: "rgba(10,10,10,0.72)", backdropFilter: "blur(6px)" }
        : { minHeight: "100vh", background: "var(--black)" }),
      display: "flex", alignItems: "center", justifyContent: "center",
      flexDirection: "column", gap: 16, color: "var(--green)",
    }}>
      <svg width="48" height="48" viewBox="0 0 48 48" xmlns="http://www.w3.org/2000/svg">
        <circle cx="24" cy="24" r="20" fill="#808080"/>
        <path d="M24 24 L24 4 A20 20 0 0 1 44 24 Z" fill="#00FF00" fillOpacity="0.7"
          style={{ transformOrigin:"24px 24px", animation:"spin 1.2s linear infinite" }}/>
        <circle cx="24" cy="24" r="3" fill="#00FF00" fillOpacity="0.7"/>
      </svg>
      <span className="t-title" style={{ fontSize:16, letterSpacing:2 }}>{message}</span>
    </div>
  );
}
